import React from "react";
import type { IconType } from "react-icons";

interface TextInputProps {
  id: string;
  name: string;
  label?: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  icon?: IconType;
  newClassName?: string;
  disabled?: boolean;
  inputMode?:
    | "text"
    | "search"
    | "email"
    | "tel"
    | "url"
    | "none"
    | "numeric"
    | "decimal";
  maxLength?: number;
  optional?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({
  id,
  name,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  required = false,
  error = false,
  errorMessage,
  icon: Icon,
  newClassName = "",
  disabled = false,
  inputMode = "text",
  maxLength,
  optional = false,
}) => {
  return (
    <div className="mb-2.5">
      {/* Label */}
      <label htmlFor={id} className="textInputLabel">
        {label}
        {required && <span className="textInputLabelRequired">*</span>}
        {optional && <span className="textInputLabelOptional">(optional)</span>}
      </label>

      {/* Input Field */}
      <div
        className={`textInputContainer ${
          error
            ? "textInputContainerError"
            : disabled
            ? "bg-gray-200"
            : "textInputContainerActive"
        }`}
      >
        {Icon && (
          <div className="textInputIcon">
            <Icon size={20} />
          </div>
        )}

        <input
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`textInputArea ${newClassName}`}
          disabled={disabled}
          autoComplete="off"
          inputMode={inputMode}
          maxLength={maxLength}
        />
      </div>

      {/* Error Message */}
      {error && (
        <p className="textInputErrorMessage">
          {errorMessage || `Field is required, ${label}`}
        </p>
      )}
    </div>
  );
};

export default TextInput;
